import {Text} from '@chakra-ui/react';
import {Flex, Box} from '@chakra-ui/layout';
import {FC} from 'react';
import {ModalTypes, useModalContext} from '..';

export const titles: Record<ModalTypes, string | string[]> = {
  certificate: 'Your digital certificate',
  redeem: ['Gift Code'],
  share: 'Share to social',
  deed: '',
  wallet: '',
};

const MainTitle = (text: string): JSX.Element => {
  const {redeemCode} = useModalContext();

  return (
    <Text w="100%" css={{'span:nth-child(2)': {fontWeight: 400}}} color="white">
      <Box w="100%" as="span" textStyle={{base: 'h6', md: 'h5'}}>
        {text}
      </Box>
      <Box as="span" textStyle={{base: 'h6', md: 'h5'}}>
        {redeemCode && `: ${redeemCode}`}
      </Box>
    </Text>
  );
};

const SubTitle = (text: string): JSX.Element => (
  <Text textStyle={{base: 'body4', md: 'body3'}} color="white">
    {text}
  </Text>
);

export const Title: FC<{text: string | string[]}> = ({text}): JSX.Element =>
  Array.isArray(text) ? (
    <Flex w="100%" flexDirection="column">
      {MainTitle(text[0])}
      {SubTitle(text[1])}
    </Flex>
  ) : (
    <Flex w="100%">{MainTitle(text)}</Flex>
  );
